export const FOOTFALL_AREAS_TABLE_ID = 'footfall_areas_table'
